<script>
export default {
  methods: {
    getStaticPath (fileName) {
      return fileName ? require('../../../assets/' + fileName) : ''
    },
    getFormatedDate (date) {
      var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      var formatedDate = date
      var now = new Date(Date.now())
      var diffYear = now.getFullYear() - date.getFullYear()
      var diffDay = Math.abs(now.getTime() - date.getTime()) / (1000 * 3600 * 24)
      if (diffYear > 1) {
        formatedDate = '' + date.getFullYear()
      } else if (diffDay > 10) {
        formatedDate = monthNames[date.getMonth()] + ' ' + date.getDate() + ', ' + date.getFullYear()
      } else if (diffDay > 2) {
        formatedDate = diffDay + ' days ago'
      } else if (diffDay > 1) {
        formatedDate = 'yesterday'
      } else {
        formatedDate = 'today'
      }
      return formatedDate
    },
    trimTextToLength (string, length) {
      return string.length > length ? string.substring(0, length - 3) + '...' : string
    }
  }
}
</script>



// WEBPACK FOOTER //
// UtilityMixin.vue?02b17323